export const text = {
  titulo: "Todo el sabor de Carta Blanca ",
  tituloDesk: "hasta tu mesa sin salir de casa.",
  subtitulo: "Encuéntralas aquí",
};
export const stores = [
  {
    src: require("@/assets/img/buy/walmart.png"),
    link:
      "https://super.walmart.com.mx/cervezas/cerveza-clara-carta-blanca-caguamita-6-botellas-de-300-ml-c-u/00750302441645",
    alt: "WALMART",
  },
  {
    src: require("@/assets/img/buy/superama.png"),
    link:
      "https://www.superama.com.mx/catalogo/d-vinos-y-licores/f-cervezas/l-clara/cerveza-clara-carta-blanca-6-pack-355-ml-c-u/0750106165154",
    alt: "SUPERAMA",
  },
  {
    src: require("@/assets/img/buy/chedraui.png"),
    link:
      "https://www.chedraui.com.mx/Departamentos/Vinos-y-Licores/Cervezas/Cerveza-Clara-Carta-Blanca-6-Pack-Lata-355-ml/p/000000000003233522?siteName=Sitio+de+Chedraui",
    alt: "CHEDRAUI",
  },
  {
    src: require("@/assets/img/buy/rappi.png"),
    link: "https://www.rappi.com.mx/",
    alt: "RAPPI",
  },
  {
    src: require("@/assets/img/buy/cornershop.png"),
    link:
      "https://cornershopapp.com/es-mx/products/mxss-carta-blanca-cerveza-caguamita-la-comer",
    alt: "CORNERSHOP",
  },
  {
    src: require("@/assets/img/buy/heb.png"),
    link:
      "https://www.heb.com.mx/promociones/heineken/carta-blanca-cerveza-six-pack-caguamita-300-ml-719055.html",
    alt: "HEB",
  },
  {
    src: require("@/assets/img/buy/mercadolibre.png"),
    link:
      "https://www.mercadolibre.com.mx/cerveza-carta-blanca-lager-lata-355-ml-24-u/p/MLM16016521#searchVariation=MLM16016521[…]-b120-422e-9610-fb3f39cac0e5",
    alt: "MERCADO LIBRE",
  },
  {
    src: require("@/assets/img/buy/soriana.png"),
    link:
      "https://superentucasa.soriana.com/default.aspx?p=13351&s=11433863&temprefer=18162359",
    alt: "SORIANA",
  },
];
